import React from 'react';
import { Icon } from './Icon';

const TrashIcon = ({ size }: Props) => {
  return (
    <Icon type="trash" color="bg-label-dark" size={size} />
  );
}

interface Props {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

export { TrashIcon };